import { useCallback, useEffect, useRef, useState } from "react";

import { useUser } from "MVVM/Hooks/useUser";
import {
  addAttributionParams,
  getAttributionUserId,
} from "MVVM/Utilities/Attribution";

const COPIED_MS = 2000;

// One clipboard path for every share affordance on the match page: stamps
// attribution, survives a blocked clipboard, and reports back for 2s.
export const useCopyLink = () => {
  const { allstarUser } = useUser();
  const [copied, setCopied] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => () => clearTimeout(timer.current), []);

  const copy = useCallback(
    async (url: string) => {
      const withRef = addAttributionParams(
        url,
        getAttributionUserId(allstarUser),
      );

      try {
        await navigator.clipboard.writeText(withRef);
      } catch {
        // Clipboard is permission gated and absent over plain http. Saying
        // nothing is worse than saying it did not copy.
        window.prompt("Copy this link", withRef);
        return false;
      }

      setCopied(true);
      clearTimeout(timer.current);
      timer.current = setTimeout(() => setCopied(false), COPIED_MS);
      return true;
    },
    [allstarUser],
  );

  return { copied, copy };
};
